<template>
    <header id="header_wrap">
        <section>
            <a href="javascript:void(0);" class="header_logo" aria-label="서울 시각 장애인 생활 이동지원센터 메인페이지로 이동" @click="main" tabindex="1" ><img aria-hidden="true" role="button" src="../../assets/images/img_logo.png" alt="서울특별시 서울시각장애인 생활 이동지원센터 로고" /></a>
            <nav class="header_nav">
                <ul class="header_quick" role="presentation">
                    <li class="hl_btn" title="메뉴 버튼" @click="sideMenuToggle"><a aria-label="메뉴" role="button" href="javascript:void(0);" tabindex="3">메뉴</a></li>
                    <li class="hr_btn" title="로그인 버튼" @click="login" v-if="$store.state.session == null">
                        <a aria-label="로그인" role="button" href="javascript:void(0);" tabindex="2">로그인</a>
                    </li>
                    <li class="hr_btn" title="로그아웃 버튼" @click="logout" v-if="$store.state.session != null">
                        <a aria-label="로그아웃" role="button" href="javascript:void(0);" tabindex="2">로그아웃</a>
                    </li>
<!--                    <li class="hr_btn" title="회원가입" @click="doRegist" v-if="$store.state.session == null">-->
<!--                      <a href="javascript:void(0);" tabindex="4">이용 신청</a>-->
<!--                    </li>-->
                </ul>
            </nav>
        </section>
    </header>
</template>

<script>
export default {
    /*data() {
        return {
            watchInterval: null,
            watch_cnt:0
        }
    },
    mounted() {
        this.watchCall();

        this.$eventBus.$on('watchCall', () => {
            this.clearWatch();
            this.watchCall();
        });
    },*/
    methods: {        
        sideMenuToggle() {
            this.$emit('sideMenuToggle');
        },
        doRegist() {
            this.$router.push('/m/member/registClass')
        },
        main() {
            this.$router.push('/m');
        },
        login() {
            this.$router.push('/m/login');
        },
        logout() {
            this.$http.get("/api/logout.do").then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    this.$store.commit("setSession", null);
                    this.$router.push("/m");
                } else {
                    alert("로그아웃 처리를 실패하였습니다.");
                }
            });
        }/*,
        watchCall() {
            if(this.$store.state.session != null) {
                console.log('watch call...');

                this.$http.get('/api/order/progress.do', null, false).then((response) => {
                    if(response.data.retval == this.CONSTANT.SUCCESS) {
                        let callInfo = response.data.callInfo;

                        // 인터발 설정
                        if(this.watchInterval == null) {
                            console.log('set watchCall interval');
                            this.watchInterval = setInterval(this.watchCall, 10000);
                        }

                        // 접수, 차량 요청 중
                        if(callInfo.ds_status == 1 || callInfo.ds_status == 2 || callInfo.ds_status == 3) {
                            this.$store.commit('setCallInfo', callInfo);
                        // 차량 위치 조회
                        } else if(callInfo.ds_status == 5) {
                            // 차량 위치 확인
                            this.watchCar(callInfo);
                        } else {                            
                            // 인터발 해제
                            this.clearWatch();

                            if(callInfo.ds_status == 6) {
                                alert("차량이 출발지에 도착하였습니다. 탑승하여 주세요.");
                            }
                        }
                    } else {
                        // 인터발 해제
                        this.clearWatch();

                            this.$store.commit("setSession", null);
                        }

                        this.$store.commit('setCallInfo', null);
                    }
                }).catch(error => {
                    // 인터발 해제
                    this.clearWatch();
                    this.$store.commit('setCallInfo', null);
                });
            }
        },
        watchCar(callInfo) {
            if(this.$store.state.session != null) {
                console.log('watch car...');

                this.$http.get('/api/order/callRemainDist.do', null, false).then((response) => {
                    if(response.data.retval == this.CONSTANT.SUCCESS) {
                        callInfo.dist = response.data.dist;

                        if(callInfo.dist <= 300) {                            
                            alert("차량이 곧 도착할 예정입니다.");
                        }
                    } else {
                        // 인터발 해제
                        this.clearWatch();
                    }

                    this.$store.commit('setCallInfo', callInfo);
                }).catch(error => {
                    // 인터발 해제
                    this.clearWatch();
                    this.$store.commit('setCallInfo', null);
                });
            }
        },
        clearWatch() {
            console.log('clear interval');
            if(this.watchInterval != null) {
                clearInterval(this.watchInterval);
                this.watchInterval = null;
            }
        }*/
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/common/Header.vue